import { render } from "./FindPassword.vue?vue&type=template&id=433bf25a&scoped=true"
import script from "./FindPassword.vue?vue&type=script&lang=js"
export * from "./FindPassword.vue?vue&type=script&lang=js"

import "@/assets/css/layout_login.css?vue&type=style&index=0&id=433bf25a&scoped=true&lang=css"

import exportComponent from "C:\\DEVER\\meta-buysell.vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-433bf25a"]])

export default __exports__